export default {
    EXAME_LABORATORIAL: 7,
    EXAME_IMAGEM: 8,
    TRANSPORTE_PACIENTE: 12,
}